import { useTranslate, Title } from 'react-admin';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Card, CardActionArea, Typography, Grid } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';


const Dashboard = () => {
	const translate = useTranslate();
	const sections = [
		{
			title: translate('dashboard.userManagement'),
			path: '/user',
			icon: <PeopleIcon fontSize="large" color="primary" />
		},
	];
	
	const pageTitle = translate('dashboard.title');
	const systemName = translate('system.name');
	
	return (
		<>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<Title title={pageTitle} />
			<Grid container spacing={3} sx={{p: 4}}>
				{sections.map(({title, path, icon}) => (
					<Grid size={{xs: 12, sm: 6,md: 4}} key={path}>
						<Card elevation={3} sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
							<CardActionArea component={Link} to={path} sx={{p: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flexGrow: 1}}>
								{icon}
								<Typography variant="h6" sx={{ mt: 1 }}>{title}</Typography>
							</CardActionArea>
						</Card>
					</Grid>
				))}
			</Grid>
		</>
	);
};

export default Dashboard;
